module.exports = {"TXTWCL_Convert_Funds":{"id":"TXTWCL_Convert_Funds","defaultMessage":"資金を両替する","track":"Convert Funds"}}